import { Analytics } from '@plaudit/analytics';
import * as $ from 'jquery';
import Channel from './Channel';


export default class ChannelLineup {
	private lineupEl: HTMLElement = document.querySelector('.channelLineup');
	private analytics: Analytics;
	private selectors: {
		form: '.channelLineup__filterForm',
		table: '.channelLineup__table',
		thead: '.channelLineup__thead',
		viewText: '.channelLineup__viewText'
		channel: '.channel'
	};

	constructor() {
		if (!this.lineupEl) {
			return;
		}

		this.analytics = Analytics.getInstance();
		this.initStickyContainer();
		this.initViewText();
		this.initChannelFilter();
	}

	private initStickyContainer() {
		const stickyContainer: HTMLElement = document.getElementById('cboxLoadedContent');
		if (!stickyContainer) { return; }

		const stickyElement: HTMLElement = this.lineupEl.querySelector('.channelLineup thead');
		stickyContainer.addEventListener('scroll', (event) => {
			const element: HTMLElement = event.currentTarget as HTMLElement;
			if (element.scrollTop > 0) {
				stickyElement.classList.add('js-is-stuck');
			} else {
				stickyElement.classList.remove('js-is-stuck');
			}
		});
	}

	private initViewText() {
		const viewTextBtn = this.lineupEl.querySelector('.channelLineup__viewText');
		if (!viewTextBtn) { return; }

		let toggled = false;
		viewTextBtn.addEventListener('click', (event: MouseEvent) => {
			if (toggled) {
				this.lineupEl.classList.remove('channelLineup--showText');
				this.analytics.trackEvent('Channel Listing', 'Control Click', 'View Logos');
				viewTextBtn.textContent = 'View Text';
			} else {
				this.lineupEl.classList.add('channelLineup--showText');
				this.analytics.trackEvent('Channel Listing', 'Control Click', 'View Text');
				viewTextBtn.textContent = 'View Logos';
			}
			toggled = !toggled;
		});
	}

	private initChannelFilter() {
		const filterForm = this.lineupEl.querySelector('.channelLineup__filterForm');
		const channelList = this.lineupEl.querySelectorAll('.channel');
		if (!filterForm || !channelList.length) { return; }

		this.lineupEl.querySelector('#tv-everywhere-checkbox-area').addEventListener('click', (event: Event) => {
			const evt = document.createEvent("Event");
			evt.initEvent("submit", true, true);
			filterForm.dispatchEvent(evt);
		});

		// Assemble Channel object array from channels
		const buildChannels = (): Channel[] => {
			const channels: Channel[] = [];
			for (let i = 0; i < channelList.length; i++) {
				channels.push(new Channel({ element: channelList[i] }));
			}
			return channels;
		};
		const myChannels = buildChannels();

		// Initialize empty activeFilter object
		let activeFilter = {
			text: '',
			tvEverywhere: false,
		};
		filterForm.addEventListener('submit', (event: Event) => {
			event.preventDefault();
			const formValueArray = $(event.target).serializeArray();

			// Needs to be reset as form doesn't always send all values
			activeFilter.text = '';
			activeFilter.tvEverywhere = false;

			// Apply active filters from form values
			for (let i = 0; i < formValueArray.length; i++) {
				const element = formValueArray[i];
				switch (element.name) {
					case 'filter':
						activeFilter.text = element.value;
						break;
					case 'tv-everywhere':
						activeFilter.tvEverywhere = element.value === 'on';
						break;
				}
			}

			// NOTE: Should this hook into GA search functionality somehow?
			this.analytics.trackEvent('Channel Listing', 'Search', `${activeFilter.text ? `Q: ${activeFilter.text}` : ''} | TV Everywhere: ${activeFilter.tvEverywhere.toString()}`);

			// Go through each channel and hide as necessary
			myChannels.forEach(channel => {
				channel.filter({
					filterString: activeFilter.text,
					tvEverywhere: activeFilter.tvEverywhere
				});
			});

			let offset = $('#channelLineupTable').offset();
			/* scroll to the top of the table area unless it's in a lightbox */
			if ( !$('#channelLineupTable').parents('#colorbox') ){
				$('html,body').scrollTop(offset.top);
			}
		});
	}
}
